import { useAuth } from '../../context/AuthContext';

/** The institution whose books the accounting pages show: the user's selected institution. */
export const useAccountingInstitution = (): string => {
    const { selectedInstitutionId } = useAuth();
    return selectedInstitutionId ?? '';
};
